import React from "react";
import LegalLayout from "../components/LegalLayout";
import { useT } from "../lib/i18n";

export default function Disclaimer() {
  const { t, lang } = useT();
  return (
    <LegalLayout title={t("settings.disclaimer")}>
      {lang === "en" ? (
        <>
          <h1>Disclaimer</h1>
          <p>Last updated: {new Date().toLocaleDateString("en-GB")}</p>

          <h2>AI-generated content</h2>
          <p>
            All travel plans, budgets, hotel and restaurant suggestions produced
            by TAi-P are generated by artificial intelligence for informational
            and inspirational purposes only. TAi-P does not guarantee the
            accuracy, completeness, availability, pricing, opening hours, or
            halal status of any place or service mentioned in a Travel Book.
          </p>

          <h2>Please verify before you go</h2>
          <p>
            You are responsible for verifying every practical detail directly
            with the operator (hotel, restaurant, transport provider, government
            body) before making a booking, spending money, or acting on any
            recommendation. Prices in Malaysian Ringgit shown in Travel Books
            are estimates only and may not reflect current market rates.
          </p>

          <h2>No bookings, no financial advice</h2>
          <p>
            TAi-P does not book, sell, or resell any travel product. We are not
            a licensed travel agent. Nothing in a Travel Book constitutes
            professional financial, medical, immigration, or legal advice.
          </p>

          <h2>Travel risk</h2>
          <p>
            Travel involves inherent risks. You are solely responsible for your
            safety, insurance, visa requirements, health precautions, and
            compliance with local laws at your destination.
          </p>

          <h2>Muslim-friendly information</h2>
          <p>
            Where TAi-P highlights mosques, halal restaurants, or prayer
            spaces, please verify halal certification and prayer times with the
            venue and local religious authorities before your visit.
          </p>
        </>
      ) : (
        <>
          <h1>Penafian</h1>
          <p>Kemas kini terakhir: {new Date().toLocaleDateString("ms-MY")}</p>

          <h2>Kandungan dijana AI</h2>
          <p>
            Semua rancangan perjalanan, bajet, cadangan hotel dan restoran yang
            dihasilkan oleh TAi-P dijana oleh kecerdasan buatan untuk tujuan
            maklumat dan inspirasi sahaja. TAi-P tidak menjamin ketepatan,
            kelengkapan, ketersediaan, harga, waktu operasi, atau status halal
            mana-mana tempat atau perkhidmatan yang disebut dalam Travel Book.
          </p>

          <h2>Sila sahkan sebelum anda pergi</h2>
          <p>
            Anda bertanggungjawab mengesahkan setiap butiran praktikal secara
            langsung dengan pengendali (hotel, restoran, pengangkutan, badan
            kerajaan) sebelum membuat tempahan, membelanjakan wang, atau
            bertindak berdasarkan sebarang cadangan. Harga dalam Ringgit
            Malaysia yang dipaparkan dalam Travel Book adalah anggaran sahaja
            dan mungkin tidak mencerminkan kadar pasaran semasa.
          </p>

          <h2>Tiada tempahan, tiada nasihat kewangan</h2>
          <p>
            TAi-P tidak menempah, menjual, atau menjual semula sebarang produk
            perjalanan. Kami bukan ejen pelancongan berlesen. Tiada apa-apa
            dalam Travel Book merupakan nasihat profesional kewangan,
            perubatan, imigresen, atau undang-undang.
          </p>

          <h2>Risiko perjalanan</h2>
          <p>
            Perjalanan melibatkan risiko yang wujud. Anda bertanggungjawab
            sepenuhnya untuk keselamatan, insurans, keperluan visa, langkah
            kesihatan, dan pematuhan undang-undang tempatan di destinasi anda.
          </p>

          <h2>Maklumat mesra Muslim</h2>
          <p>
            Apabila TAi-P menonjolkan masjid, restoran halal, atau ruang solat,
            sila sahkan pensijilan halal dan waktu solat dengan tempat berkenaan
            dan pihak berkuasa agama tempatan sebelum lawatan anda.
          </p>
        </>
      )}
    </LegalLayout>
  );
}
